import type { ReactElement } from 'react';
import RebalancingRuleList from './RebalancingRuleList';
import { useRebalancingRuleTemplatesSuspenseQuery } from 'generated/graphql';

const RebalancingRuleTemplateList = (): ReactElement => {
  const { data } = useRebalancingRuleTemplatesSuspenseQuery();

  return (
    <RebalancingRuleList
      createNewRuleUrl="/app/copilot/lab/rebalacing-rule-templates/new"
      editUrl={(id) => `/app/copilot/lab/rebalacing-rule-templates/${id}`}
      rebalancingRules={data.portfolio.definitionRuleTemplates}
    />
  );
};

export default RebalancingRuleTemplateList;
